import $ from 'jquery';
import { stringifySync } from '@bingads-webui/safe-json';
import { OCVDataService } from '@bingads-webui-react/feedback-panel';

export class SurveyDataSource extends OCVDataService {
  // eslint-disable-next-line no-useless-constructor
  constructor() {
    super();
  }

  checkCompliance() {
    return true;
  }

  getScope() {
    const searchParams = new URLSearchParams(window.location.search);
    const cid = searchParams.get('cid');
    const aid = searchParams.get('aid') || 0;
    const uid = searchParams.get('uid');

    return {
      cid,
      aid,
      uid,
    };
  }

  sendEventToReportingPipeline({ // eslint-disable-line consistent-return
    surveyName,
    feedback,
    telemetry,
    clientFeedbackId,
    serverContext,
    Interface,
    Product,
    logActivity,
  }) {
    const { cid, aid } = this.getScope();

    const option = {
      contentType: 'application/json',
      type: 'POST',
      data: stringifySync({
        data: {
          EventName: 'CSATSurvey',
          UniqueId: clientFeedbackId,
          EventValue: stringifySync({
            Rating: feedback.rating * 5, // convert to 5 star rating
            AID: aid,
            CID: cid,
            Interface,
            Product,
            SubProduct: null,
            Context: {
              DeviceType: telemetry.deviceType,
              FeatureArea: telemetry.featureArea,
            },
          }),
        },
      }),
      url: `${serverContext.ServicesEndpoints.CampaignAPI}Campaign/V2/Customers(${cid})/Accounts(${aid})/Default.PostABTestingEventLog`,
      success: /* istanbul ignore next */ () => {
        logActivity(`SurveyDataSource | survey: ${surveyName}, action: send CSAT reporting pipeline success`);
      },
      error: /* istanbul ignore next */ () => {
        logActivity(`SurveyDataSource | survey: ${surveyName}, action: send CSAT reporting pipeline failed`);
      },
    };

    return $.ajax(option);
  }
}
